module.exports = __webpack_public_path__ + "static/media/totem.17a8e001.svg";